
import { useMapMarkerStore, usePipedriveStore, useSaleCompStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import { ISaleCompState } from "../interfaces/ISaleComp";

const useSaleCompCreate = (): (saleCompState: ISaleCompState, regridId: string | null) => Promise<number> => {
    const saleCompStore = useSaleCompStore();
    const pipedriveStore = usePipedriveStore();
    const mapMarkerStore = useMapMarkerStore();

    return async (saleCompState: ISaleCompState, regridId): Promise<number> => {
        try {
            const createdSaleCompId = await saleCompStore.createSaleComp(
                {
                    ...saleCompState,
                    buyerName: saleCompState.isBuyerIndividual ? saleCompState.buyerName : null,
                    sellerName: saleCompState.isSellerIndividual ? saleCompState.sellerName : null,
                    brokerageName: saleCompState.isBrokerageIndividual ? saleCompState.brokerageName : null,
                },
                !saleCompState.isBuyerIndividual ? await pipedriveStore.getOrCreatePipedriveOrganizationId(saleCompState.buyerName) : null,
                !saleCompState.isSellerIndividual ? await pipedriveStore.getOrCreatePipedriveOrganizationId(saleCompState.sellerName) : null,
                !saleCompState.isBrokerageIndividual ? await pipedriveStore.getOrCreatePipedriveOrganizationId(saleCompState.brokerageName) : null,
                mapMarkerStore.coordinates!,
                regridId,
            );

            showSuccessToast();

            return createdSaleCompId;
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useSaleCompCreate;